import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
//import * as Sentry from '@sentry/browser';
//import ErrorPage from './ErrorPage';

// there is no hook yet for componentDidCatch so have to use a class component instead of a function component
export class ErrorBoundaryDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
  // handleReportClick = (e) => {
  //   e.preventDefault();

  //   // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
  //   // const { eventId } = this.state;
  //    //Sentry.showReportDialog({ eventId });
  // };

  refresh = () => {
    window.location.reload();
  };

  // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
  //componentDidCatch(error ,errorInfo) {
  componentDidCatch(error) {
    // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
    //const { environmentName } = this.props;

    this.setState({ error });
    // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
    //if (environmentName !== 'Development') {
    // Sentry.withScope((scope) => {
    //   scope.setExtra('errorInfo', errorInfo);
    //   const eventID = Sentry.captureException(error);
    //   this.setState({ eventId: eventID });
    // });
    //}
  }

  render() {
    // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
    //const { error } = this.state;

    // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
    //const { children, useRefresh } = this.props;
    const { children } = this.props;

    // SEPARATION-TECH-DEBT CORP-828 Comment out Sentry code
    // if (error) {
    //   return <ErrorPage onReportClick={this.handleReportClick} useRefresh={useRefresh} refresh={this.refresh} />;
    // }

    // When there's not an error render the children
    return children;
  }
}

ErrorBoundaryDisplay.propTypes = {
  environmentName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  useRefresh: PropTypes.bool,
};

ErrorBoundaryDisplay.defaultProps = {
  useRefresh: false,
};

export const mapStateToProps = (state) => {
  return {
    environmentName: state.defaults.environmentName,
  };
};

export default connect(mapStateToProps, {})(ErrorBoundaryDisplay);
